/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Delete_Account_SubtitleInputs */

const es_user_profile_delete_account_subtitle = /** @type {(inputs: User_Profile_Delete_Account_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar permanentemente su cuenta y todos los datos asociados`)
};

const en_user_profile_delete_account_subtitle = /** @type {(inputs: User_Profile_Delete_Account_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanently delete your account and all associated data`)
};

/**
* | output |
* | --- |
* | "Permanently delete your account and all associated data" |
*
* @param {User_Profile_Delete_Account_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_delete_account_subtitle = /** @type {((inputs?: User_Profile_Delete_Account_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Delete_Account_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_delete_account_subtitle(inputs)
	return en_user_profile_delete_account_subtitle(inputs)
});
export { user_profile_delete_account_subtitle as "user.profile.delete_account.subtitle" }